import { useMemo } from 'react';
import { fichiersDeConversation, signatureFichiers } from './fichiers.js';

/**
 * Liens vérifiés de fichiers de la conversation (contrat v1.13) : même objet tant que la liste
 * ne change pas, pour que le texte en cours d'arrivée ne refasse pas les vignettes.
 */
export function useLiensVerifies(messages) {
  const fichiers = fichiersDeConversation(messages);
  const signature = signatureFichiers(fichiers);
  // Dépendance volontaire : la signature, pas l'objet recalculé à chaque rendu
  return useMemo(() => fichiers, [signature]);
}
